import styled from 'styled-components';
import { Icon, Typography } from '../../stories/atoms';
import { RowFlexContainer } from '../../stories/atoms/containerV2/ContainerV2';

export const StyledNote = styled(RowFlexContainer)`
  & > * {
    color: ${({ theme: { color, palette } }) =>
      palette.mode === 'dark' ? color.warningLight : color.warningDark};
  }
`;

export const ButtonsContainer = styled(RowFlexContainer)`
  align-self: flex-end;
  & > *:first-of-type {
    margin-right: ${({ theme: { spacing } }) => spacing(5)};
  }
`;

export const StyledIcon = styled(Icon)`
  width: ${({ theme: { spacing } }) => spacing(8)};
  height: ${({ theme: { spacing } }) => spacing(8)};
  padding: ${({ theme: { spacing } }) => spacing(2)};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundSelectedHover : color.borderGray};
  justify-content: center;
  cursor: pointer;
`;

export const StyledTypography = styled(Typography)<{ isDisabled: boolean }>`
  color: ${({ theme: { color, palette }, isDisabled }) =>
    isDisabled && (palette.mode === 'dark' ? color.borderGrayDark : color.textGray)};
`;
